export enum LoginStage {
  consumerLogin = "consumer",
  email = "email",
  password = "password",
  device = "device",
  secondFactor = "second-factor",
  success = "success",
  error = "error",
  updatePassword = "update-password"
}
